import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tracked",
  "use": "icon-tracked-usage",
  "viewBox": "0 0 16.36 15.56",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.36 15.56\" id=\"icon-tracked\"><defs><style>#icon-tracked .cls-1{fill:#0df;}</style></defs><g id=\"icon-tracked_圖層_2\" data-name=\"圖層 2\"><g id=\"icon-tracked_圖層_1-2\" data-name=\"圖層 1\"><polygon class=\"cls-1\" points=\"8.18 0 10.71 5.12 16.36 5.94 12.27 9.93 13.24 15.56 8.18 12.9 3.13 15.56 4.09 9.93 0 5.94 5.65 5.12 8.18 0\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol